import { OverviewPage } from "fleet/view/overview/overview";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import {
  ACCOUNT_STATS_LOAD_BY_DATE,
  accountEventsSelector,
  deviceAverageUptimeSelector,
} from "redux-store/ui-state/account-stats";

function mapStateToProps(state) {
  return {
    averageUptime: deviceAverageUptimeSelector(state),
    events: accountEventsSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAccountStats: (serviceArgs) => {
      const { yesterday } = serviceArgs;
      return createPromiseApiAction(dispatch, ACCOUNT_STATS_LOAD_BY_DATE, [
        yesterday,
      ]);
    },
  };
}

const ConnectedOverview = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OverviewPage);

export { ConnectedOverview };
